import React from 'react';
import { Card } from '../../components/ui/Card';
import { TabNavigation } from '../../components/operations/TabNavigation';
import { Bot, TrendingUp, AlertTriangle, Lightbulb, Repeat, Gift, Clock, ThumbsUp, ThumbsDown } from 'lucide-react';
const CUSTOMER_TABS = [{
  label: 'Overview',
  path: ''
}, {
  label: 'Database',
  path: 'database'
}, {
  label: 'Segments',
  path: 'segments'
}, {
  label: 'Reviews',
  path: 'reviews'
}, {
  label: 'Insights',
  path: 'insights'
}];
export function Insights() {
  return <div className="space-y-6 animate-in fade-in duration-500" data-id="element-827">
      <h1 className="text-2xl font-bold text-text-primary" data-id="element-828">
        Customer Insights
      </h1>
      <TabNavigation tabs={CUSTOMER_TABS} basePath="/customers" data-id="element-829" />

      {/* AI Insights Box */}
      <Card className="border border-accent-primary/30 bg-accent-primary/5 relative overflow-hidden" data-id="element-830">
        <div className="absolute top-0 right-0 p-4 opacity-10" data-id="element-831">
          <Bot size={120} data-id="element-832" />
        </div>
        <div className="relative z-10" data-id="element-833">
          <h3 className="font-bold text-accent-primary flex items-center gap-2 mb-4 text-lg" data-id="element-834">
            <Bot size={24} data-id="element-835" /> AI INSIGHTS
          </h3>
          <div className="space-y-3" data-id="element-836">
            <div className="flex gap-3 items-start" data-id="element-837">
              <TrendingUp className="text-accent-success shrink-0 mt-1" size={18} data-id="element-838" />
              <p data-id="element-839">
                New customer acquisition up 15% — Instagram ads performing well
              </p>
            </div>
            <div className="flex gap-3 items-start" data-id="element-840">
              <AlertTriangle className="text-accent-warning shrink-0 mt-1" size={18} data-id="element-841" />
              <p data-id="element-842">
                Banovo Brdo has 2x more negative reviews than average —
                investigate
              </p>
            </div>
            <div className="flex gap-3 items-start" data-id="element-843">
              <Lightbulb className="text-yellow-400 shrink-0 mt-1" size={18} data-id="element-844" />
              <p data-id="element-845">
                VIP customers order 40% more on weekends — consider weekend
                loyalty bonus
              </p>
            </div>
            <div className="flex gap-3 items-start" data-id="element-846">
              <Repeat className="text-blue-400 shrink-0 mt-1" size={18} data-id="element-847" />
              <p data-id="element-848">
                28% of new customers return within 14 days — above industry
                average (22%)
              </p>
            </div>
            <div className="flex gap-3 items-start" data-id="element-849">
              <Gift className="text-accent-primary shrink-0 mt-1" size={18} data-id="element-850" />
              <p data-id="element-851">
                WhatsApp loyalty members have 3x higher retention than
                non-members
              </p>
            </div>
          </div>
        </div>
      </Card>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-852">
        {/* Retention Funnel */}
        <Card className="p-6" data-id="element-853">
          <h3 className="font-bold mb-6" data-id="element-854">Retention Funnel</h3>
          <div className="space-y-4" data-id="element-855">
            {[{
            label: '1st order',
            pct: 100,
            width: '100%'
          }, {
            label: '2nd order',
            pct: 52,
            width: '52%'
          }, {
            label: '3rd order',
            pct: 38,
            width: '38%'
          }, {
            label: '4th order',
            pct: 28,
            width: '28%'
          }, {
            label: '5th+ orders',
            pct: 22,
            width: '22%'
          }].map((step, i) => <div key={i} data-id="element-856">
                <div className="flex justify-between text-sm mb-1" data-id="element-857">
                  <span className="font-medium" data-id="element-858">{step.label}</span>
                  <span className="font-bold" data-id="element-859">{step.pct}%</span>
                </div>
                <div className="h-6 bg-white/5 rounded overflow-hidden" data-id="element-860">
                  <div className="h-full bg-accent-primary/80" style={{
                width: step.width
              }} data-id="element-861"></div>
                </div>
              </div>)}
          </div>
        </Card>

        {/* Customer Lifetime Value */}
        <Card className="p-6" data-id="element-862">
          <h3 className="font-bold mb-6" data-id="element-863">Customer Lifetime Value</h3>
          <div className="space-y-4" data-id="element-864">
            <div className="flex justify-between items-center p-3 bg-white/5 rounded-lg" data-id="element-865">
              <span className="text-text-secondary" data-id="element-866">New customer avg LTV</span>
              <span className="font-bold" data-id="element-867">8,500 RSD</span>
            </div>
            <div className="flex justify-between items-center p-3 bg-white/5 rounded-lg" data-id="element-868">
              <span className="text-text-secondary" data-id="element-869">
                Regular customer avg LTV
              </span>
              <span className="font-bold" data-id="element-870">45,000 RSD</span>
            </div>
            <div className="flex justify-between items-center p-3 bg-accent-primary/10 rounded-lg border border-accent-primary/20" data-id="element-871">
              <span className="text-accent-primary font-medium" data-id="element-872">
                VIP customer avg LTV
              </span>
              <span className="font-bold text-accent-primary" data-id="element-873">125,000 RSD</span>
            </div>
            <div className="flex justify-between items-center p-3 bg-white/5 rounded-lg" data-id="element-874">
              <span className="text-text-secondary" data-id="element-875">
                Loyalty member avg LTV
              </span>
              <span className="font-bold" data-id="element-876">68,000 RSD</span>
            </div>
            <div className="mt-4 pt-4 border-t border-white/10 text-center text-sm text-text-secondary" data-id="element-877">
              Avg time to VIP status:{' '}
              <span className="text-white font-bold" data-id="element-878">4.5 months</span>
            </div>
          </div>
        </Card>

        {/* Order Frequency */}
        <Card className="p-6" data-id="element-879">
          <h3 className="font-bold mb-6 flex items-center gap-2" data-id="element-880">
            <Clock size={20} data-id="element-881" /> Order Frequency by Segment
          </h3>
          <div className="space-y-4" data-id="element-882">
            {[{
            label: 'VIP',
            freq: 'Every 5 days',
            width: '90%',
            color: 'bg-accent-primary'
          }, {
            label: 'Regular',
            freq: 'Every 8 days',
            width: '60%',
            color: 'bg-yellow-500'
          }, {
            label: 'Returning',
            freq: 'Every 12 days',
            width: '40%',
            color: 'bg-teal-500'
          }].map((item, i) => <div key={i} data-id="element-883">
                <div className="flex justify-between text-sm mb-1" data-id="element-884">
                  <span className="font-medium" data-id="element-885">{item.label}</span>
                  <span className="text-text-secondary" data-id="element-886">{item.freq}</span>
                </div>
                <div className="h-2 bg-white/10 rounded-full overflow-hidden" data-id="element-887">
                  <div className={`h-full ${item.color}`} style={{
                width: item.width
              }} data-id="element-888"></div>
                </div>
              </div>)}
          </div>
        </Card>

        {/* WhatsApp Loyalty Stats */}
        <Card className="p-6" data-id="element-889">
          <h3 className="font-bold mb-6 flex items-center gap-2 text-accent-success" data-id="element-890">
            <Gift size={20} data-id="element-891" /> WhatsApp Loyalty Stats
          </h3>
          <div className="grid grid-cols-2 gap-4 mb-6" data-id="element-892">
            <div className="bg-white/5 p-3 rounded-lg text-center" data-id="element-893">
              <div className="text-xs text-text-secondary uppercase mb-1" data-id="element-894">
                Total Members
              </div>
              <div className="font-bold text-xl" data-id="element-895">456</div>
            </div>
            <div className="bg-white/5 p-3 rounded-lg text-center" data-id="element-896">
              <div className="text-xs text-text-secondary uppercase mb-1" data-id="element-897">
                Active (Month)
              </div>
              <div className="font-bold text-xl" data-id="element-898">312 (68%)</div>
            </div>
            <div className="bg-white/5 p-3 rounded-lg text-center" data-id="element-899">
              <div className="text-xs text-text-secondary uppercase mb-1" data-id="element-900">
                Points Redeemed
              </div>
              <div className="font-bold text-xl" data-id="element-901">45,000</div>
            </div>
            <div className="bg-white/5 p-3 rounded-lg text-center" data-id="element-902">
              <div className="text-xs text-text-secondary uppercase mb-1" data-id="element-903">
                Redemption Rate
              </div>
              <div className="font-bold text-xl" data-id="element-904">23%</div>
            </div>
          </div>
          <div className="text-sm bg-accent-success/10 p-3 rounded-lg text-center text-accent-success font-medium" data-id="element-905">
            Top reward: Free delivery (156 redemptions)
          </div>
        </Card>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-906">
        {/* Common Complaints */}
        <Card className="p-6 border border-accent-error/20" data-id="element-907">
          <h3 className="font-bold mb-4 flex items-center gap-2 text-accent-error" data-id="element-908">
            <ThumbsDown size={20} data-id="element-909" /> Common Complaints
          </h3>
          <div className="space-y-3" data-id="element-910">
            {[{
            text: '"Slow delivery"',
            count: 34
          }, {
            text: '"Cold food"',
            count: 23
          }, {
            text: '"Wrong order"',
            count: 18
          }, {
            text: '"Packaging issue"',
            count: 12
          }].map((item, i) => <div key={i} className="flex justify-between items-center p-2 bg-white/5 rounded" data-id="element-911">
                <span className="font-medium" data-id="element-912">{item.text}</span>
                <span className="text-sm text-text-secondary" data-id="element-913">
                  {item.count} mentions
                </span>
              </div>)}
          </div>
        </Card>

        {/* Top Praise */}
        <Card className="p-6 border border-accent-success/20" data-id="element-914">
          <h3 className="font-bold mb-4 flex items-center gap-2 text-accent-success" data-id="element-915">
            <ThumbsUp size={20} data-id="element-916" /> Top Praise
          </h3>
          <div className="space-y-3" data-id="element-917">
            {[{
            text: '"Great burgers"',
            count: 156
          }, {
            text: '"Fast delivery"',
            count: 89
          }, {
            text: '"Good packaging"',
            count: 67
          }, {
            text: '"Friendly"',
            count: 45
          }].map((item, i) => <div key={i} className="flex justify-between items-center p-2 bg-white/5 rounded" data-id="element-918">
                <span className="font-medium" data-id="element-919">{item.text}</span>
                <span className="text-sm text-text-secondary" data-id="element-920">
                  {item.count} mentions
                </span>
              </div>)}
          </div>
        </Card>
      </div>
    </div>;
}